const getEventTypeCategory = (eventType, eventTypes) => {
  if (eventType && eventTypes[eventType.eventType]) {
    return eventTypes[eventType.eventType].name
  }
  return ''
}

export default getEventTypeCategory
